<template>
  <div>
    <h3>
      设置
      <p class="fr timeinfo">上一次登录：{{ userInfo.lastLoginTime }}</p>
    </h3>
    <el-form ref="form" :model="form" label-width="85px" class="setform">
      <el-form-item prop="url" label="用户头像">
        <el-upload
          class="uploader fl book-uploader"
          :action="uploadurl"
          name="iconFile"
          :headers="headers"
          :on-success="handlebookSuccess"
        >
          <img
            v-if="form.iconUrlSmall"
            :src="form.iconUrlSmall"
            class="userurl"
            width="150px"
            height="150px"
          />
          <img
            src="~img/personal/default_head@2x.png"
            v-else
            class="el-icon-plus avatar-uploader-icon"
          />
        </el-upload>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="form.id" readonly class="readonly"></el-input>
      </el-form-item>
      <el-form-item label="手机号" v-if="form.mobile">
        <el-input v-model="form.mobile" readonly class="readonly"></el-input>
      </el-form-item>
      <el-form-item label="登录方式">
        <el-input
          v-html="
            form.loginType == 1
              ? '手机号'
              : form.loginType == 2
              ? 'qq'
              : form.loginType == 3
              ? '微信'
              : '邮箱'
          "
          readonly
          class="readonly"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" v-if="form.loginType == 1">
        <a
          v-if="!form.hasPassword"
          href="javaScript:"
          class="setpassword"
          @click="setPass"
          >设置密码</a
        >
        <a
          v-if="form.hasPassword"
          href="javaScript:"
          class="setpassword"
          @click="changePass"
          >修改密码</a
        >
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmitname">保存</el-button>
      </el-form-item>
    </el-form>
    <div class="optionPass" v-show="showOption">
      <div class="optionbox" v-show="showSet">
        <h3>
          <p>
            设置密码
            <span class="line"></span>
          </p>
          <img
            src="~img/personal/Group30@2x.png"
            class="closeop"
            @click="closeOption"
            alt=""
          />
        </h3>
        <el-form
          class="passbox"
          ref="setpassform"
          :rules="setrules"
          :model="setpassform"
          label-width="76px"
        >
          <el-form-item prop="password" label="设置密码">
            <el-input
              v-model="setpassform.password"
              class="login-form-input"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="repeatPassword" label="确认密码">
            <el-input
              v-model="setpassform.repeatPassword"
              class="login-form-input"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitpass('setpassform')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="optionbox changebox" v-show="showChange">
        <h3>
          <p>
            修改密码
            <span class="line"></span>
          </p>
          <img
            src="~img/personal/Group30@2x.png"
            class="closeop"
            @click="closeOption"
            alt=""
          />
        </h3>
        <el-form
          class="passbox"
          ref="changepassform"
          :model="changepassform"
          :rules="rules"
          label-width="76px"
        >
          <el-form-item prop="password" label="原始密码">
            <el-input
              v-model="changepassform.password"
              class="login-form-input"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="passwordNew" label="修改密码">
            <el-input
              v-model="changepassform.passwordNew"
              class="login-form-input"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="passwordRepeat" label="确认密码">
            <el-input
              v-model="changepassform.passwordRepeat"
              class="login-form-input"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitChange('changepassform')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "utils/storage";
import {
  getuserInfo,
  changeUsername,
  setPassword,
  changePassword
} from "apiurl/login";
import { BENDI } from "apiurl/index.js";
import { isPwd, encryptStr } from "utils/core/kernel";
import { mapState } from "vuex";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (isPwd(value)) {
        callback();
      } else {
        callback(new Error("请输入6-20位字母大小写数字特殊符号"));
      }
    };
    return {
      form: {
        iconUrlSmall: "",
        id: 123456,
        name: "ahha",
        mobile: null,
        loginType: 1
      },
      userInfo: {},
      uploadurl: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      setpassform: {
        password: "",
        repeatPassword: ""
      },
      changepassform: {
        password: "",
        passwordNew: "",
        passwordRepeat: ""
      },
      showSet: false,
      showChange: false,
      showOption: false,
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        passwordNew: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        passwordRepeat: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      },
      setrules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        repeatPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.$nextTick(() => {
      // 获取用户信息
      this.getInfo();
    });
  },
  computed: mapState({
    info: state => state.user.img
  }),
  methods: {
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      if (res.success) {
        this.userInfo = res.data;
        this.form = {
          iconUrlSmall: this.imgURL + res.data.iconUrlSmall,
          id: res.data.id,
          name: res.data.name,
          hasPassword: res.data.hasPassword,
          mobile: res.data.mobile,
          loginType: res.data.loginType
        };
      }
    },
    handlebookSuccess(res, file, fileList) {
      if (res.success) {
        this.form.iconUrlSmall = this.imgURL + res.data.iconUrl;
        this.$message({
          message: "头像已上传",
          type: "success"
        });
        this.info.iconUrlSmall = res.data.iconUrl;
        this.$store.dispatch("saveInfo", this.info);
        if (fileList.length > 1) {
          fileList = fileList.splice(0, fileList.length - 1);
        }
      } else {
        fileList = [];
        this.$message({
          message: "头像上传失败",
          type: "error"
        });
      }
    },
    // 修改用户昵称
    async onSubmitname() {
      let res = await changeUsername({ userName: this.form.name });
      if (res.success) {
        this.$message({
          message: "用户名修改成功",
          type: "success"
        });
        this.info.name = this.form.name;
        this.$store.dispatch("saveInfo", this.info);
      }
    },
    // 设置
    setPass() {
      this.showOption = true;
      this.showSet = true;
    },
    // 修改
    changePass() {
      this.showOption = true;
      this.showChange = true;
    },
    // 关闭
    closeOption() {
      this.showOption = false;
      this.showSet = false;
      this.showChange = false;
    },
    // 设置密码
    submitpass(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.setpassform.password === this.setpassform.repeatPassword) {
            setPassword({
              password: encryptStr(this.setpassform.password),
              repeatPassword: encryptStr(this.setpassform.repeatPassword)
            }).then(res => {
              if (res.success) {
                this.$message({
                  message: "成功设置密码！",
                  type: "success"
                });
                this.showOption = false;
                this.showSet = false;
                this.getInfo();
              }
            });
          } else {
            this.$message({
              message: "两次密码输入不一致",
              type: "error"
            });
          }
        }
      });
    },
    // 修改密码
    submitChange(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          changePassword({
            password: encryptStr(this.changepassform.password),
            passwordNew: encryptStr(this.changepassform.passwordNew),
            passwordRepeat: encryptStr(this.changepassform.passwordNew)
          }).then(res => {
            if (res.success) {
              this.$message({
                message: "密码修改成功！",
                type: "success"
              });
              this.showOption = false;
              this.showChange = false;
            }
          });
        }
      });
    }
  },
  mounted() {
    // 上传图片地址
    this.uploadurl = `${BENDI}/account/icon/save`;
  }
};
</script>
<style>
.setform .el-form-item__label {
  font-size: 16px;
  color: #333333;
  text-align: left;
}
.setform .el-button--primary {
  width: 159px;
  height: 40px;
}
.passbox .el-button {
  width: 159px;
  height: 40px;
  border: none;
  margin-left: 25px;
}
.optionPass
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.optionPass
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-right: 4px;
}
</style>

<style lang="stylus" scoped>
.setform
    margin 24px
    padding-right 190px
    img
        width 106px
        height 106px
    .setpassword
        display block
        line-height 20px
        text-align center
        margin-top 10px
        width 58px
        height 20px
        background rgba(72, 162, 223, 1)
        border-radius 2px
        font-size 12px
        color #fff
.optionPass
    position fixed
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.5)
    top 0px
    left 0px
    z-index 100
    .optionbox
        width 459px
        height 287px
        background rgba(255, 255, 255, 1)
        box-shadow 0px 3px 12px 0px rgba(0, 0, 0, 0.19)
        border-radius 14px
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        margin auto
        &.changebox
            height 346px
        .passbox
            margin 25px 43px
        h3
            border-radius 14px 14px 0 0
            background #fff
            position relative
            p
                width 72px
                font-size 18px
                color rgba(51, 51, 51, 1)
                margin-left 170px
                span
                    width 33px
                    height 4px
                    background rgba(209, 236, 255, 1)
                    border-radius 4px
                    display block
                    margin-left 20px
            img
                position absolute
                width 14px
                height 14px
                right 21px
                top 21px
</style>
